export default "__VITE_ASSET__BQOm8e5u__"